import { useTranslation } from "react-i18next";
import { ExternalLink, LogOut } from "lucide-react";

import { LanguageSwitcher } from "@/components/layout/language-switcher";
import { ThemeToggle } from "@/components/layout/theme-toggle";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { getStaffRoleLabel } from "@/lib/admin";
import { APP_URL } from "@/lib/api";
import { logout } from "@/lib/auth";
import { useSession } from "@/lib/session-context";

export function AdminHeader() {
  const { t } = useTranslation("admin");
  const { user } = useSession();
  const role = getStaffRoleLabel(user);

  function handleLogout() {
    void logout();
  }

  return (
    <header className="flex h-14 shrink-0 items-center gap-3 border-b border-border bg-background px-4">
      <SidebarTrigger />
      <div className="flex flex-1 items-center justify-end gap-2">
        <ThemeToggle />
        <LanguageSwitcher />
        <Button
          variant="outline"
          size="sm"
          render={
            <a href={APP_URL} target="_blank" rel="noopener noreferrer" />
          }
        >
          <ExternalLink className="size-4" />
          {t("header.openApp")}
        </Button>
        {user ? (
          <Badge variant="secondary" className="hidden sm:inline-flex">
            {t(`roles.${role}`)}
          </Badge>
        ) : null}
        <Button variant="ghost" size="sm" onClick={() => void handleLogout()}>
          <LogOut className="size-4" />
          <span className="hidden sm:inline">{t("header.logout")}</span>
        </Button>
      </div>
    </header>
  );
}
